export const PROVINCES = [
  "Eastern Cape", "Free State", "Gauteng", "KwaZulu-Natal", "Limpopo",
  "Mpumalanga", "North West", "Northern Cape", "Western Cape",
];

const norm = (s) => (s || "").toLowerCase().replace(/[^a-z]/g, "");

export const toProvince = (region) => PROVINCES.find((p) => norm(p) === norm(region)) || null;

export const PHONE_RE = /^\d{3}-\d{3}-\d{4}$/;

export const formatPhone = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 10);
  return [d.slice(0, 3), d.slice(3, 6), d.slice(6)].filter(Boolean).join("-");
};
